
import {post} from '@/utils/request';
import{erpplatserver,erpserver} from '@/utils/baseUrl';
//文件上传
export async function uploadFile(params) {
    return post(erpplatserver+'/system/uploadFile', params, false)
}
//文件上传
export async function upload(params) {
    return post(erpserver+'/attendence/upload', params, true)
}
//导入保存
export async function save(params) {
    return post(erpserver+'/attendence/save', params, true)
}
//打卡列表
export async function records(params) {
    return post(erpserver+'/attendence/file/records', params, true)
}
//考勤方案列表
export async function getKqList(params) {
    return post(erpserver+'/kq/getKqList', params, true)
}
//搜索框模糊查询
export async function searchUser(params) {
    return post(erpserver+'/attendence/searchUser', params, true)
}
//搜索框模糊查询
export async function result(params) {
    return post(erpserver+'/attendence/result', params, true)
}
//获取班次列表
export async function getbcdetailList(params) {
    return post(erpserver+'/kq/getbcdetailList', params, true)
}
